// 从 context 中获取 fx 函数对参照的翻译值
export function getFxExpression(VALUE, context = {}, attrCode) {
    let reslut = JSON.parse(JSON.stringify(VALUE));
    // let attrCode = '';
    let mainOrgVal = attrCode === 'pk_org_v' ? context.pk_org_v : context.pk_org || '';
    let mainOrgDis = attrCode === 'pk_org_v' ? context.org_v_Name : context.org_Name || '';
    // if (mainOrgVal && attrCode === 'pk_org' && Array.isArray(context.permOrgs) && !context.permOrgs.includes(mainOrgVal)) {
    //     mainOrgVal = '';
    // }
    if(VALUE && ['@SYSUSER', '@SYSOPER', '@SYSDEPT', '@SYSCORP'].includes(VALUE.value) && context.sysvalueMap && context.sysvalueMap[VALUE.value]){
        return {
            ...VALUE,
            ...{
                display: context.sysvalueMap && context.sysvalueMap[VALUE.value],
                value: VALUE.value
            }
        };
    }

    let fxObj = {
        '#mainorg#': {
            // 默认主组织
            display: mainOrgVal ? mainOrgDis : '',
            value: mainOrgVal,
        },
        '#DefaultCostRegion#': {
            // 默认财务成本域
            display: context.defaultCostRegionName || '',
            value: context.defaultCostRegionPk || '',
        },
        '#DefaultCreditCtlRegion#': {
            //默认信用域
            display: context.defaultCreditCtlRegionName || '',
            value: context.defaultCreditCtlRegionPk || '',
        },
        // 下边重新定义了 accountingbook
        // '#accountingbook#': {
        //     //默认账簿
        //     display: context.defaultAccbookName || '',
        //     value: context.defaultAccbookPk || '',
        // },
        '#operator#': {
            //当前操作员
            display: context.userName || '',
            value: context.userId || '',
        },
        '#currentgroup#': {
            //当前集团
            display: context.groupName || '',
            value: context.groupId || '',
        },
        '#DefaultLiactCostrgFunction#': {
            //默认利润中心成本域
            display: context.defaultCenterContentName || '',
            value: context.defaultCenterContentPK || '',
        },
        "#DefaultCostrgOrLiactCostrgFunc#": {
            //默认成本域
            display: context.defaultCostRegionName || context.defaultCenterContentName || '',
            value: context.defaultCostRegionPk || context.defaultCenterContentPK || '',
        },
        "#busioperator#": {
            //当前人员
            display: context.defaultPsndocName || '',
            value: context.defaultPsndocPK || '',
        },
        "#rbacdept#": {
            //当前人员所属部门 
            display: context.defaultDeptName || '',
            value: context.defaultDeptPK || '',
        },
        "#globeorg#": {
            //全局  
            display: context.globeName || '',
            value: context.globePK || '',
        },
        "#currperiod#": {
            //当前计划周期 
            display: context.currperiodName || '',
            value: context.currperiodPK || '',
        },
        "#mainaccperiod#": {
            //默认会计期间 
            display: context.mainacceperiodName || '',
            value: context.mainAcceperiodPK || '',
        },
        "#currentaccperiod#": {
            //当前期间 
            display: context.currentAccperiodName || '',
            value: context.currentAccperiodPk || '',
        },
        "#rbacdeptsubincluded#": {
            //用户主职部门及其下级  数组
            display: Array.isArray(context.defaultDeptsubincludedName) ? context.defaultDeptsubincludedName.join(',') : context.defaultDeptsubincludedName || '',
            value: Array.isArray(context.defaultDeptsubincludedPK) ? context.defaultDeptsubincludedPK.join(',') : context.defaultDeptsubincludedPK || '',
        },
        "#rbacdeptpartsuperall#": {
            //用户主职部门及兼职部门及其上级部门
            display: Array.isArray(context.rbacdeptpartsuperallName) ? context.rbacdeptpartsuperallName.join(',') : context.rbacdeptpartsuperallName || '',
            value: Array.isArray(context.rbacdeptpartsuperallPk) ? context.rbacdeptpartsuperallPk.join(',') : context.rbacdeptpartsuperallPk || '',
        },
        "#firstaccperiod#": {
            //第一个期间 
            display: context.fristAccperiodName || '',
            value: context.fristAccperiodPK || '',
        },
        "#accountingbook#": {
            //默认（总账）账簿 
            display: context.accountingBookName || '',
            value: context.accountingBookPk || '',
        },
        "#psndocdeptOrg#": {
            //兼职部门
            display: Array.isArray(context.psndocDeptOrgName) ? context.psndocDeptOrgName.join(',') : context.psndocDeptOrgName || '',
            value: Array.isArray(context.psndocDeptOrgPK) ? context.psndocDeptOrgPK.join(',') : context.psndocDeptOrgPK || '',
        },
         "#userorganization#": {
            //用户所属组织 
            display: context.userorganizationName || '',
            value: context.userorganizationPK || '',
        },
        '#rbacdept_v#': {
            //用户所属部门 
            display: context.defaultDept_vName || '',
            value: context.defaultDept_vPK || '',
        },
        "#rbacdeptpart#": {
            //用户主职部门及其兼职部门
            display: Array.isArray(context.defaultDeptPartName) ? context.defaultDeptPartName.join(',') : context.defaultDeptPartName || '',
            value: Array.isArray(context.defaultDeptPartPK) ? context.defaultDeptPartPK.join(',') : context.defaultDeptPartPK || '',
        },
        "#rbacdeptpart_v#": {
            //用户主职部门及其兼职部门多版本
            display: Array.isArray(context.defaultDeptPart_VName) ? context.defaultDeptPart_VName.join(',') : context.defaultDeptPart_VName || '',
            value: Array.isArray(context.defaultDeptPart_VPK) ? context.defaultDeptPart_VPK.join(',') : context.defaultDeptPart_VPK || '',
        },
        "#rbacdeptup#": {
            // 上级部门
            display: context.defaultDeptUpName || '',
            value:  context.defaultDeptUpPk || '',
        },
        "#rbacdeptpartsubincluded#": {
            //默认（总账）账簿 
            display: context.rbacdeptpartsubincludedName || '',
            value: context.rbacdeptpartsubincludedPK || '',
        },
        "#rbacdeptandpartsubincluded#": {
            //默认（总账）账簿 
            display: context.rbacdeptandpartsubincludedName || '',
            value: context.rbacdeptandpartsubincludedPK || '',
        },
        '#rbacdeptsupersubincluded#': {
            //用户主职部门上级及其下级部门
            display: Array.isArray(context.rbacdeptsupersubincludedName) ? context.rbacdeptsupersubincludedName.join(',') : context.rbacdeptsupersubincludedName || '',
            value: Array.isArray(context.rbacdeptsupersubincludedPK) ? context.rbacdeptsupersubincludedPK.join(',') : context.rbacdeptsupersubincludedPK || '',
        }
    };

    if (Array.isArray(reslut)) {
        reslut.map(item => {
            if (item.value && item.value.indexOf('#') !== -1) {
                item = fxObj[item.value] ? { ...VALUE, ...fxObj[reslut.value] } : item;
            }
            //  else if (attrcode === 'pk_org' && item.value && Array.isArray(context.permOrgs) && !context.permOrgs.includes(item.value)) {
            //     item.value = '';
            //     item.display = '';
            // }
            return item;
        });
    } else {
        if (reslut.value && reslut.value.indexOf('#') !== -1) {
            reslut = fxObj[reslut.value] ? { ...VALUE, ...fxObj[reslut.value] } : reslut;
        }
        //  else if (attrcode === 'pk_org' && reslut.value && Array.isArray(context.permOrgs)) {
        //     let vArray = reslut.value.split(',');
        //     let DisArray = reslut.display.split(',');
        //     let filterVal = [];
        //     let filterDis = [];
        //     for (let index = 0; index < vArray.length; index++) {
        //         let el = vArray[index];
        //         if (context.permOrgs.includes(el)) {
        //             filterVal.push(el);
        //             filterDis.push(DisArray[index]);
        //         }
        //     }
        //     reslut.value = filterVal.join(',');
        //     reslut.display = filterDis.join(',');
        // }
    }
    return reslut;
}